import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';

const C = {
  navy: '#0b1120',
  blue: '#6699ff',
  blueDark: '#4d7ae6',
  cream: '#f5f0e8',
  creamLight: '#faf7f2',
  creamWarm: '#ede5d8',
  textDark: '#0d1520',
  textBody: '#3a4860',
  textMuted: '#6b7a92',
  white: '#ffffff',
};

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate('/spc-portal-1003');
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: C.navy,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Manrope', sans-serif",
    }}>
      <div style={{
        background: C.white, padding: 56, width: 420,
        position: 'relative',
      }}>
        <div style={{
          position: 'absolute', top: -1, left: 40, right: 40, height: 2,
          background: `linear-gradient(90deg, transparent, ${C.blue}, transparent)`,
        }} />

        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 4, textTransform: 'uppercase', color: C.blue, marginBottom: 12 }}>
            Admin Portal
          </div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 500, color: C.textDark }}>
            Steel Process Consultancy
          </div>
        </div>

        {error && (
          <div style={{
            padding: '12px 16px', background: '#fef2f2', border: '1px solid #fecaca',
            color: '#dc2626', fontSize: 13, marginBottom: 20, borderRadius: 2,
          }}>
            {error}
          </div>
        )}

        <div>
          <label style={{ display: 'block', fontSize: 10, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', color: C.textBody, marginBottom: 8 }}>
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@steelprocess.com"
            style={{
              width: '100%', padding: '14px 16px', border: `1px solid ${C.creamWarm}`,
              background: C.creamLight, fontFamily: "'Manrope', sans-serif", fontSize: 14,
              color: C.textDark, outline: 'none', marginBottom: 20,
            }}
            onFocus={e => { e.target.style.borderColor = C.blue; e.target.style.background = C.white; }}
            onBlur={e => { e.target.style.borderColor = C.creamWarm; e.target.style.background = C.creamLight; }}
          />

          <label style={{ display: 'block', fontSize: 10, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', color: C.textBody, marginBottom: 8 }}>
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            style={{
              width: '100%', padding: '14px 16px', border: `1px solid ${C.creamWarm}`,
              background: C.creamLight, fontFamily: "'Manrope', sans-serif", fontSize: 14,
              color: C.textDark, outline: 'none', marginBottom: 28,
            }}
            onFocus={e => { e.target.style.borderColor = C.blue; e.target.style.background = C.white; }}
            onBlur={e => { e.target.style.borderColor = C.creamWarm; e.target.style.background = C.creamLight; }}
            onKeyDown={e => { if (e.key === 'Enter') handleLogin(e); }}
          />

          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              width: '100%', padding: 18, background: C.blue, color: C.navy, border: 'none',
              fontFamily: "'Manrope', sans-serif", fontSize: 12, fontWeight: 700,
              letterSpacing: 2.5, textTransform: 'uppercase', cursor: loading ? 'wait' : 'pointer',
              opacity: loading ? 0.7 : 1, transition: 'all 0.3s ease',
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </div>
      </div>
    </div>
  );
}